<div class="w-100 mt-0 tool-container">
  <h4>Upload Handlebar Template</h4>
  <mat-form-field class="me-3">
    <mat-label>Mapping ID</mat-label>
    <input matInput [(ngModel)]="uploadHandlebarTemplate.id" />
  </mat-form-field>
  <span class="file-container">
    <input
      type="file"
      class="file-input"
      (change)="onFileSelected($event)"
      #handlebarUpload
    />

    <span class="file-upload">
      {{ handlebarFileName || 'No file selected yet' }}

      <button
        mat-mini-fab
        color="primary"
        class="upload-btn"
        (click)="handlebarUpload.click()"
      >
        <mat-icon>attach_file</mat-icon>
      </button>
    </span>
  </span>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="uploadHandlebarTemplateFile()"
    [disabled]="!uploadHandlebarTemplate.id || !handlebarFile"
  >
    Upload
  </button>
  @if (uploadHandlebarTemplate.status) {
    <h4 class="col-12 {{ uploadHandlebarTemplate.statusClass }}">
      {{ uploadHandlebarTemplate.status }}
    </h4>
  }
</div>
